function Member(props) {
	const redirectToWebsite = (website) => {
		if (website !== undefined)
			window.location.href = props.website
	}
	return (
		<div className="member" onClick={() => redirectToWebsite(props.website)}>
			<div className="member-image">
				<img src={props.url} alt="" />
			</div>
			<div className="member-name">{props.name}</div>
			<div>({props.designation})</div>
			<div className="member-research">Research Interests</div>
			<div className="member-desc">{props.desc}</div>
			{/* <div className="member-contact">{props.contact}</div> */}
			{/* <div className="member-contact">{props.contact}[at]cse[dot]iitk[dot]ac[dot]in</div> */}
		</div>
	);
}

export default Member;
